import { DocFilterContentInterface } from '../interfaces/doc-filter-content.interface';

export class DsDocFiltersCheckModel {
  /**
   *
   */
  public name__contains: string;

  /**
   *
   */
  public created_before: string;

  /**
   *
   */
  public created_after: string;

  /**
   *
   */
  public tags: string;

  /**
   *
   */
  public creator_email: string;

  /**
   *
   */
  public visa__status: string;

  /**
   *
   */
  public visa__status__strict: string;

  /**
   *
   */
  public visa__deadline_after: string;

  /**
   *
   */
  public visa__deadline_before: string;

  /**
   *
   */
  public visa__past__deadline: boolean;

  /**
   *
   */
  public has__visa: string;

  /**
   * Creates an instance of DsDocFilter.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DocFilterContentInterface) {
    if (jsonData?.name__contains) this.name__contains = jsonData?.name__contains;
    if (jsonData?.created_after) this.created_after = jsonData?.created_after;
    if (jsonData?.created_before) this.created_before = jsonData?.created_before;
    if (jsonData?.tags) this.tags = jsonData?.tags;
    if (jsonData?.creator_email) this.creator_email = jsonData?.creator_email;
    this.has__visa = jsonData?.has__visa || null;
    if (jsonData?.visa__past__deadline) this.visa__past__deadline = jsonData?.visa__past__deadline;
    if (jsonData?.visa__status) this.visa__status = jsonData?.visa__status;
    if (jsonData?.visa__status__strict) this.visa__status__strict = jsonData?.visa__status__strict;
    if (jsonData?.visa__deadline_after) this.visa__deadline_after = jsonData?.visa__deadline_after;
    if (jsonData?.visa__deadline_before) this.visa__deadline_before = jsonData?.visa__deadline_before;
  }
}
